import { Icon } from '@chakra-ui/react';

const HouseSimpleIcon = (props) => (
  <Icon viewBox="0 0 16 16" {...props} fill="none">
    <g id="HouseSimple">
      <path
        id="Vector"
        d="M13.3375 6.85001L8.3375 2.30626C8.24533 2.22194 8.12493 2.17517 8 2.17517C7.87507 2.17517 7.75467 2.22194 7.6625 2.30626L2.6625 6.85001C2.61219 6.89753 2.57189 6.95463 2.54398 7.01796C2.51607 7.08129 2.50112 7.14957 2.5 7.21876V13C2.5 13.1326 2.55268 13.2598 2.64645 13.3536C2.74021 13.4473 2.86739 13.5 3 13.5H13C13.1326 13.5 13.2598 13.4473 13.3536 13.3536C13.4473 13.2598 13.5 13.1326 13.5 13V7.21876C13.4989 7.14957 13.4839 7.08129 13.456 7.01796C13.4281 6.95463 13.3878 6.89753 13.3375 6.85001V6.85001Z"
        stroke="#8D8186"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </Icon>
);

export default HouseSimpleIcon;
